document.querySelectorAll( '.b-accordion' ).forEach( ( block ) => {

	const titleElements = block.querySelectorAll( '.b-accordion-single__title-wrapper' );

	titleElements.forEach( ( titleElement ) => {

		titleElement.addEventListener( 'click', function handleClick() {

			const accordionItem = titleElement.closest( '.b-accordion-single' );
			accordionItem.classList.toggle( 'b-accordion-single__active' );

			const contentElement = accordionItem.querySelector( '.b-accordion-single__content' );

			if ( contentElement.style.maxHeight ) {

				contentElement.style.maxHeight = null;

			} else {

				contentElement.style.maxHeight = `${ contentElement.scrollHeight }px`;

			}

		} );

	} );

} );

